import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { onReadyWidgetOfType } from '../utils/helper';

onReadyWidgetOfType("ImageCarouselWidgetProperties", (widget, data) => {
    //console.log({ widget, data })
    const swiperElement = widget.querySelector(".image-carousel-widget-swipper")
    const pagination = widget.querySelector(".swiper-pagination")

    /**
     * @type {import('swiper').Swiper}
     */
    var swiper = new Swiper(swiperElement, {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: pagination,
            clickable: true,
        },
        loop: data.loop,
        // autoplay: data.autoplay ? { delay: 5000 } : false,
        resizeEvent: 'auto'
        // navigation: {
        //     nextEl: nextEl,
        //     prevEl: prevEl,
        // },
    })

    let countdownElement = document.querySelector('.timer');

    let countdownTime = data.autoplay && data.autoplay.delay ? data.autoplay.delay : 5000; // Set the countdown based on the autoplay delay
    let interval; // Declare a variable for the interval outside so it can be cleared and reset

    function resetAndStartTimer(delay) {
        clearInterval(interval); 
        countdownElement.innerText = (delay / 1000).toFixed(1); // Initial display
        interval = setInterval(() => {
            delay -= 100; 
            countdownElement.innerText = (delay / 1000).toFixed(1); // Update display
            if (delay <= 0) {
                clearInterval(interval); // Clear interval when countdown finishes
            }
        }, 100); 
    }

    // Start the timer when Swiper initializes
    if (data.autoplay) {
        resetAndStartTimer(countdownTime);
    }

    // Listen to the 'slideChange' event to reset the timer
    swiper.on('slideChange', function () {
        if (swiper.autoplay.running && data.autoplay) {
            resetAndStartTimer(countdownTime);
        }
    });

    
    
})
